import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';

import {MySortButtonStatesEnum} from '../../../../enums/my-sort-button-states.enum';
import {ProjectsTableService} from '../../../../services/projects-table.service';

@Component({
    selector: 'app-column-header',
    templateUrl: './column-header.component.html',
    styleUrls: ['./column-header.component.scss']
})
export class ColumnHeaderComponent implements OnDestroy, OnChanges {


    @Input() public label: string;
    @Input() public columnId: string;
    @Input() public showSortBtn = true;
    @Input() public defaultState = MySortButtonStatesEnum.DISABLED;

    private bntSubscription: Subscription;

    @Input() public state: MySortButtonStatesEnum = MySortButtonStatesEnum.DISABLED;

    @Output() public sortBtnClicked = new EventEmitter<{ columnId: string, state: MySortButtonStatesEnum }>();


    public faName = 'sort';

    constructor(private tableService: ProjectsTableService) {
        this.bntSubscription = this.tableService.disableAllButtonsRequestAnnounced$.subscribe(id => {

            if (this.columnId !== id) {
               this.disableSortButton();
            }
        });
    }

    public disableSortButton() {
        this.state = MySortButtonStatesEnum.DISABLED;
        this.faName = 'sort';
    }

    public onSortBtnClicked() {





        this.tableService.announceDisableAllButtonsRequest(this.columnId);
        if (this.state === 0)
        {
            this.state = 2;
        }
        else
        {

            if (this.state === 2) {
                this.state = 1;
            } else {
                this.state++;
            }
        }

       this.highlightActiveState();

        this.sortBtnClicked.emit({columnId: this.columnId ? this.columnId : this.label, state: this.state});
    }



    private highlightActiveState(){
        switch (this.state) {
            case MySortButtonStatesEnum.DESCENT:
                this.faName = 'sort-up';
                break;
            case MySortButtonStatesEnum.ASCENT:
                this.faName = 'sort-down';
                break;
            default:
                this.faName = 'sort';
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {



        if( this.defaultState ) {


            this.state = this.defaultState;
            this.defaultState = undefined;
            this.highlightActiveState();
        }
    }

    public isHighlighted(): boolean {
        return  this.state !== MySortButtonStatesEnum.DISABLED;
    }

    public ngOnDestroy(): void {
        this.bntSubscription.unsubscribe();
    }
}
